import { jsx } from '@amazon/vinyl-tsx'
import { Icon } from '@/components/Icon'

export function ImagePlaceholder() {
    return (
        <div className={'iconImagePlaceholder'}>
            <Icon icon="album" />
        </div>
    )
}
